import React from "react"
import { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import {
  Menu,
  MenuItem,
  IconButton,
  Box,
  Tooltip,
  colors,
  Dialog,
  AppBar,
  Typography,
  Toolbar,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core"
import {
  MoreVertIcon,
  EditIcon,
  CloseIcon,
  DeleteIcon,
  SaveIcon,
  CancelIcon,
  VisibilityIcon,
} from "@iconsGallery"
import HistoryIcon from "@material-ui/icons/History"
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline"
import styled from "styled-components"
import AuditLogPopup from "../../pages/logviewer/auditLogs/AuditLogPopup"
import Slide from "@material-ui/core/Slide"
import _ from "lodash"

const MenuListParentWrapper = styled.div`
  .MuiIconButton-root {
    width: 20px;
    margin: auto;
    display: flex;
  }
`
const MenuListWrapper = styled.div`
  box-shadow: 0px 2px 2px #0000008f;
  border: 1px solid #eaeaea;
`

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "var(--primaryColor)",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  tooltipText: {
    color: "#fff !important",
  },
  viewTooltip: {
    backgroundColor: "var(--primaryColor) !important",
  },
  viewTooltipArrow: {
    color: "var(--primaryColor) !important",
  },
  historyTooltip: {
    backgroundColor: "#8F8F8E !important",
  },
  historyTooltipArrow: {
    color: "#8F8F8E",
  },
  deleteTooltip: {
    backgroundColor: "#D94D4A !important",
  },
  deleteTooltipArrow: {
    color: "#D94D4A",
  },
}))

function ActionMenu(props) {
  const {
    isInlineEditAllowed = false,
    historyPopup = true,
    deleteIconHolder = false,
    deleteIconTooltip = false,
    deleteTooltip = () => "Delete",
    forceHideEdit = false,
    isInlineDeleteAllowed = true
  } = props
  const [actionsState, setActionsState] = useState(null)
  const [isOpen, setOpen] = useState(false)
  const [scroll, setScroll] = React.useState("paper")

  const isDeleteDisabled =
    typeof props.deleteDisabled === "function"
      ? props.deleteDisabled(props.data)
      : props?.data?.subscription_status || false

  const tooltipTitle =
    isDeleteDisabled &&
      typeof props.deleteTooltip === "function" &&
      props.deleteTooltip(props.data) !== "Delete"
      ? props.deleteTooltip(props.data)
      : isDeleteDisabled
        ? deleteIconTooltip || "Delete"
        : deleteIconTooltip || "Delete"


  const classes = useStyles()
  const tooltipColors = props?.tooltipColors || {}
  const getTooltipClasses = (type) => {
    if (type === "view" && tooltipColors?.view) {
      return {
        tooltip: `${classes.tooltipText} ${classes.viewTooltip}`,
        arrow: classes.viewTooltipArrow,
      }
    }
    if (type === "history" && tooltipColors?.history) {
      return {
        tooltip: `${classes.tooltipText} ${classes.historyTooltip}`,
        arrow: classes.historyTooltipArrow,
      }
    }
    if (type === "delete" && tooltipColors?.delete) {
      if (isDeleteDisabled && tooltipColors?.history) {
        return {
          tooltip: `${classes.tooltipText} ${classes.historyTooltip}`,
          arrow: classes.historyTooltipArrow,
        }
      }
      return {
        tooltip: `${classes.tooltipText} ${classes.deleteTooltip}`,
        arrow: classes.deleteTooltipArrow,
      }
    }
    return undefined
  }

  const handleClickOpen = (scrollType) => {
    setOpen(true)
    setScroll(scrollType)
  }

  const handlePopClose = () => {
    setOpen(false)
    document.body.style.overflow = "scroll"
    document.body.style.paddingRight = "0px"
  }

  const ITEM_HEIGHT = 45

  const handleMenu = (event) => {
    setActionsState(event.currentTarget)
  }

  const descriptionElementRef = React.useRef(null)
  React.useEffect(() => {
    if (isOpen) {
      const { current: descriptionElement } = descriptionElementRef
      if (descriptionElement !== null) {
        descriptionElement.focus()
      }
    }
  }, [isOpen])

  const handleClose = (event) => {
    setActionsState(null)
  }

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />
  })

  let isDisableFunction =
    props.menutype === "master" ? false : !isInlineEditAllowed

  return (
    <>
      {props.data.inEdit ? (
        <>
          <Box style={{ display: "flex", justifyContent: "center" }}>
            <Tooltip title="Save" placement="top" onClick={props.save}>
              <IconButton key={"save"} style={{ padding: "10px" }}>
                <SaveIcon style={{ color: colors.green[600] }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cancel" placement="top" onClick={props.cancel}>
              <IconButton key={"cancel"} style={{ padding: "10px" }}>
                <CancelIcon style={{ color: colors.red[400] }} />
              </IconButton>
            </Tooltip>
          </Box>
        </>
      ) : (
        <Box style={{ display: "flex", justifyContent: "center" }}>
          {forceHideEdit === false && (
            <Tooltip
              title={props.menutype === "master" ? "View" : "Edit"}
              placement="top"
              classes={getTooltipClasses("view")}
            >
              <div onClick={isDisableFunction ? () => { } : props.in_edit}>
                <IconButton
                  key={"edit"}
                  disabled={
                    props.menutype === "master" ? false : !isInlineEditAllowed
                  }
                  style={{ padding: "10px" }}
                >
                  {props.menutype === "master" ? (
                    <VisibilityIcon style={{ color: "var(--primaryColor)" }} />
                  ) : (
                    <EditIcon
                      style={{
                        color: isInlineEditAllowed
                          ? "var(--primaryColor)"
                          : "#ccc",
                        pointer: isInlineEditAllowed ? "cursor" : "none",
                      }}
                    />
                  )}
                </IconButton>
              </div>
            </Tooltip>
          )}
          {isInlineEditAllowed && historyPopup && forceHideEdit === false && (
            <Tooltip
              title={"History"}
              placement="top"
              classes={getTooltipClasses("history")}
            >
              <div
                onClick={() => {
                  setOpen(true)
                }}
              >
                <IconButton style={{ padding: "10px" }}>
                  <HistoryIcon />
                </IconButton>
              </div>
            </Tooltip>
          )}
          {props?.deleteIcon && (
            <>
              {isInlineDeleteAllowed && <Tooltip
                title={tooltipTitle}
                placement="top"
                classes={getTooltipClasses("delete")}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    cursor:
                      isDeleteDisabled || !isInlineDeleteAllowed
                        ? "not-allowed"
                        : "pointer",
                  }}
                  onClick={() => {
                    if (isDeleteDisabled) {
                      if (typeof props.onDeleteDisabled === "function") {
                        props.onDeleteDisabled(props.data)
                      }
                      return
                    }
                    if (isInlineDeleteAllowed) {
                      props.delete()
                    }
                  }}
                >
                  <IconButton
                    style={{
                      padding: "5px",
                      color: isDeleteDisabled ? "#ccc" : "#f8364d",
                      pointerEvents:
                        isDeleteDisabled || !isInlineDeleteAllowed
                          ? "none"
                          : "auto",
                    }}
                    disabled={!isInlineDeleteAllowed || isDeleteDisabled}
                    tabIndex={-1}
                    onClick={(event) => {
                      event.stopPropagation()
                      if (!isDeleteDisabled && isInlineDeleteAllowed) {
                        props.delete()
                      }
                    }}
                  >
                    {deleteIconHolder ? deleteIconHolder : <DeleteOutlineIcon />}
                  </IconButton>
                </span>
              </Tooltip>}
            </>
          )}
        </Box>
      )}

      <Dialog
        fullScreen
        open={isOpen}
        onClose={handlePopClose}
        TransitionComponent={Transition}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        style={{
          maxWidth: "1000px",
          width: "60%",
          left: "auto",
          right: "0",
          display: isOpen === true ? "block" : "none",
        }}
      >
        <DialogTitle id="scroll-dialog-title" style={{ padding: "0" }}>
          <AppBar className={classes.appBar}>
            <Toolbar style={{ minHeight: "40px" }}>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handlePopClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                History List
              </Typography>
            </Toolbar>
          </AppBar>
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"} style={{ padding: "0" }}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <AuditLogPopup
              isWriteAllowed={isInlineEditAllowed}
              recordId={props?.data?._id}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ActionMenu
